module.exports = __webpack_public_path__ + "static/media/return.78a7edc4.svg";